import SubmissionTable from "components/Dashboard/SubmissionTable";
import React from "react";

interface Record {
    id: number;
    name: string;
    phone: string;
    email: string;
    alcoholtests: {
        id: number;
        data: string;
    }[];
}

interface SubmissionTableProps {
    records: Record[];
}

const RecentSubmissionTable:React.FC<SubmissionTableProps> = ({ records }) => {
    return(
        <main className="flex flex-col my-4">
            <div>
                <SubmissionTable records={records} />
            </div>
        </main>
    );
}
export default RecentSubmissionTable;